import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { environment } from '../../../environments/environment';
import { SettingsDialogComponent } from '../settings-dialog/settings-dialog.component';

@Component({
  selector: 'mpf-settings-toggle',
  templateUrl: './settings-toggle.component.html',
  styleUrls: ['./settings-toggle.component.scss']
})
export class SettingsToggleComponent {
  smartphoneDialogSize = {
    height: '100%',
    width: '100%',
    maxWidth: '100%'
  };

  constructor(private dialog: MatDialog) {}

  openSettings() {
    this.dialog.open(SettingsDialogComponent, this.getSettingsDialogConfig());
  }

  getSettingsDialogConfig() {
    const windowWidth = window.innerWidth;

    if (windowWidth < environment.screen.smartphone) {
      return this.smartphoneDialogSize;
    } else {
      return {
        height: '290px',
        width: '400px'
      };
    }
  }
}



// WEBPACK FOOTER //
// /vercel/workpath0/src/app/components/settings-toggle/settings-toggle.component.ts